import React, { HTMLAttributes } from 'react';

export const ClickConsumer = (
  props: Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>
) => (
  <div
    {...props}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
    }}
  />
);
